import { render, staticRenderFns } from "./DatatableCampaignPerformance.vue?vue&type=template&id=87c2693a"
import script from "./DatatableCampaignPerformance.vue?vue&type=script&lang=js"
export * from "./DatatableCampaignPerformance.vue?vue&type=script&lang=js"
import style0 from "./DatatableCampaignPerformance.vue?vue&type=style&index=0&id=87c2693a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports